import React from 'react'
import Container from '../components/shared/container'

function ErrorPage() {
  return <Container>ErrorPage</Container>
}

export default ErrorPage
